<template>
    <vx-popup-suggest ref="suggest" v-bind="$attrs" v-on="$listeners" v-if="isTouchDevice">
        <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
        <!-- Pass on all scoped slots -->
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope" />
        </template>
    </vx-popup-suggest>
    <elastic-suggest ref="suggest" v-bind="$attrs" v-on="$listeners" v-else>
        <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
        <!-- Pass on all scoped slots -->
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope" />
        </template>
    </elastic-suggest>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'vx-elastic-suggest',
    computed: {
        ...mapState({ isTouchDevice: 'is_touch_device' })
    },
    methods: {
        focus() {
            this.$refs.suggest && this.$refs.suggest.focus()
        },
        close() {
            this.$refs.suggest && this.$refs.suggest.close()
        }
    }
}
</script>

<style lang="scss" scoped></style>
